class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem("mer_admin"));
    return user?.refreshToken;
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("mer_admin"));
    return user?.data.authorisation.token;
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("mer_admin"));
    user.authorisation.token = token;
    localStorage.setItem("mer_admin", JSON.stringify(user));
  }

  removeUser() {
    localStorage.removeItem("mer_admin");
  }

  setMerAdmin(merAdmin) {
    localStorage.setItem("mer_admin", JSON.stringify(merAdmin));
  }

  getMember() {
    return JSON.parse(localStorage.getItem("mer_admin"));
  }

  // Stock control passcode tokens: one per branch, held apart from the merchant
  // login because the stock pages are opened straight from a public link.
  getStockAccess(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return null;
    }
  }

  setStockAccess(key, access) {
    localStorage.setItem(key, JSON.stringify(access));
  }

  removeStockAccess(key) {
    localStorage.removeItem(key);
  }
}

export default new TokenService();
